<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enable-background="new 0 0 24 24" xml:space="preserve">
  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
    <rect stroke="currentColor" x="0.5" y="2.5" width="23" height="21" rx="2"></rect>
    <rect fill="currentColor" x="1" y="9" width="22" height="1"></rect>
    <rect fill="currentColor" x="6" y="0" width="1" height="6" rx="0.5"></rect>
    <rect fill="currentColor" x="17" y="0" width="1" height="6" rx="0.5"></rect>
  </g>
</svg>
